import { API_URL } from '../../../app-config/constants';
import type { DownloadableFile } from '../../../types/DownloadableFile';
import type { MessageStatisticsDto } from '../../../types/MessageStatisticsDto';
import { get, post } from '../request';

getAll.operation = 'READ';
getAll.idFrom = (stat: MessageStatisticsDto) => stat.userId;
export function getAll(
    companyId: string,
    startDate: string,
    endDate: string,
    includeDeactivated: boolean
): Promise<MessageStatisticsDto[]> {
    return get(`${API_URL}/messages/${companyId}/usage-statistics`, {
        getData: {
            startDate,
            endDate,
            includeDeactivated: String(includeDeactivated),
        },
    });
}

export function triggerCsvDownload(companyId: string, startDate: string, endDate: string, includeDeactivated: boolean) {
    return post<DownloadableFile>(`${API_URL}/messages/${companyId}/usage-statistics/export`, {
        getData: {
            startDate,
            endDate,
            includeDeactivated: String(includeDeactivated),
        },
    });
}
